import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useVerifyCode } from '../hooks/useAuth.js';

export function AuthCallbackPage() {
  const verify = useVerifyCode();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const hash = window.location.hash.slice(1);
    const params = new URLSearchParams(hash);
    const token = params.get('token');
    if (!token) {
      setError('Missing token in link.');
      return;
    }
    verify
      .mutateAsync({ token })
      .then(() => navigate('/', { replace: true }))
      .catch(() => setError('That link is invalid or expired. Sign in to request a new one.'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="mx-auto max-w-md px-4 py-24 text-center">
      {error ? (
        <>
          <h1 className="text-xl font-semibold text-navy mb-3">Sign-in link error</h1>
          <p className="text-navy-600 mb-6">{error}</p>
          <button className="btn-primary" onClick={() => navigate('/login')}>
            Back to sign-in
          </button>
        </>
      ) : (
        <p className="text-navy-600">Signing you in…</p>
      )}
    </div>
  );
}
